//Called from _CalendarSearchFilters.js
function applyAdvancedFilters(anchorElement) {
    if ($('#filterForm').valid()) {
        var data = getDataFromFilterControls(null, null, true);
        var url = "/Calendar" + getFilterParams(data);

        if (anchorElement && typeof(anchorElement) === 'string') {
            url += '#' + anchorElement;
        }

        window.location = url;
    }
}